import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FaqSection from '@/pages/home/components/FaqSection';
import IndexSection from '@/pages/home/components/IndexSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CardsSection from '@/pages/home/components/CardsSection';
import AppSection from '@/pages/home/components/AppSection';
import AboutSection from '@/pages/home/components/AboutSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <HeroSection />
        <CarouselSection />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
        <FaqSection />
        <IndexSection />
        <TopicsSection />
        <RankingSection />
        <ContactSection />
        <CardsSection />
        <AppSection />
        <AboutSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}